var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.check())?_c('app-view-container',{attrs:{"background-src":_vm.product.background}},[_c(_vm.form,{tag:"component",on:{"togglePasswordReset":function($event){_vm.resetPassword = !_vm.resetPassword}}})],1):_c('app-loading-sheet')}
var staticRenderFns = []

export { render, staticRenderFns }